module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAtElEQVRIx2NgKDqGieoW5f25KEYkqttuzTAvAQsaNXrEGP3+nNRvGPs3mEs1o2u226w4oA9hAxlALnWMfnNOmm9BjNaykF8XxIEIyABygYJUMBquc9kBfSCCsIGC1DR66QH9pdQ1Gh4gK/YbABE1AwQSjcsP6OssDwai5VSMRkjiWwELCiCDmokPiFp2WkE0ABlUzo3vzksJLowGIiCD+hm9focVENGkDHl7TvotUsIYpiUfANaZZADs3D5QAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/vc.png
// module id = 950
// module chunks = 0